import React, { FC } from 'react';

import styles from './TableWrapper.module.scss';

export const TableWrapper: FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles.contentWrapper}>{children}</div>
);
